"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardAdicionar = void 0;
var plus_square_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/plus_square"));
var components_1 = require("@lift/design-system-react-web/dist/components");
var LftButton_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftButton"));
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importDefault(require("react"));
var tags_ga_1 = require("../../utils/tags-ga");
var card_adicionar_styles_1 = require("./card-adicionar.styles");
var CardAdicionar = function (_a) {
    var onClick = _a.onClick, labelBotao = _a.labelBotao, descricao = _a.descricao, tagsGa = _a.tagsGa;
    return (react_1.default.createElement(card_adicionar_styles_1.CardWrapperStyled, null,
        react_1.default.createElement(components_1.LftCardBase, null,
            react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small" }, descricao),
            react_1.default.createElement(tags_ga_1.TagsGa, { category: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.category, action: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.action, label: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.label },
                react_1.default.createElement(LftButton_1.default, { ariaLabel: labelBotao, actionLevel: "primary", size: "sm", icon: plus_square_1.default, lftClick: onClick }, labelBotao)))));
};
exports.CardAdicionar = CardAdicionar;
